import React from "react";
import LineItemTablesContainer from "../CBDTables/LineItemTables/LineItemTablesContainer/LineItemTablesContainer";
import AttributeGlossary from "../AttributeGlossary/AttributeGlossary";
import SummarySectionContainer from "./SummarySectionContainer";
import getProperty from "lodash.get";
import s from "./CBDView.less";
import { VIEWCBD_VER } from "../../appSettings";

const MainContent = props => (
  <div className={`${s.mainContentWrapper} container`}>
    <SummarySectionContainer ui={props.ui} />
    <LineItemTablesContainer
      summaryData={props.ui.cbdUIMapping.SummarySectionData}
      title={props.ui.tableOpen}
      totalFob={getProperty(props, ["ui", "cbdUIMapping", "fobData", "FOB"])}
    />
    <p>
      *Disclaimer: Values displayed to 2 decimals may not sum accurately to values displayed to 4
      decimals due to rounding; use the CBD export to see full decimal values.
    </p>
    <p>{`ViewCBD Version ${VIEWCBD_VER}`}</p>
    <AttributeGlossary />
  </div>
);

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/MainContent/MainContent.js